<template>
    <page>
        <fast-table
            v-if="dataLoaded"
            :sections="sections"
            :headers="headers"
            :data="tableData"
            :activeRowId="currentEarningTypeSlug"
            @click="currentEarningTypeSlug = $event.slug"
        >
            <template v-slot:table-actions>
                <button type="button" class="btn btn-primary btn-collapse-md" @click.prevent="currentEarningTypeSlug = null; addModalOpen = true">
                    <i class="far fa-fw fa-plus"></i>
                    <span class="btn-text">Add Earning Type</span>
                </button>
            </template>
        </fast-table>

        <sidebar
            :earning-type="currentEarningType"
            v-if="currentEarningTypeSlug"
            @updated="onUpdate($event)"
            @deleted="currentEarningTypeSlug = null; getData()"
            @close="currentEarningTypeSlug = null"
        />
        <add-modal v-if="addModalOpen" @updated="getData()" @close="addModalOpen = false" />

    </page>
</template>

<script>
import FastTable from '@/components/FastTable'
import Page from '@/components/Page'
import AddModal from './components/EarningTypeModal'
import Sidebar from './components/EarningTypeSidebar'

export default {
    components: {FastTable, Page, Sidebar, AddModal, },
    computed: {
        currentEarningType() {
            return this.earningTypes.find(e => e.slug == this.currentEarningTypeSlug)
        },
        tableData() {
            const sectionData = this.earningTypes.map((e, idx) => ({
                id: idx,
                isActive: this.currentEarningTypeSlug && e.slug == this.currentEarningTypeSlug,
                object: e,
                cells: [
                    e.name,
                    e.type_pretty,
                    e.symmetry_wage_type_pretty,
                    e.is_virtual,
                    e.sort_priority,
                ],
            }))
            return [sectionData]
        },
    },
    data() {
        return {
            earningTypes: [],
            dataLoaded: false,
            currentEarningTypeSlug: null,
            addModalOpen: false,

            headers: [
                {label: 'Earning Type', classes: '', isSearchable: true},
                {label: 'Type', classes: 'cw-5', isFilterable: true},
                {label: 'Sym. Wage Type', classes: 'cw-8', isFilterable: true},
                {label: 'Is Virtual', classes: 'cw-6', type: 'checkmark', isFilterable: true},
                {label: 'Sort Priority', classes: 'cw-5', defaultSort: true},
            ],
            sections: [
                {title: '', defaultIsClosed: false, id: 1},
            ],
        }
    },
    mounted() {
        this.$store.dispatch('SET_PAGE_TITLE', 'Tax Engine / Earning Types')
        this.getData()
    },
    methods: {
        getData() {
            this.dataLoaded = false
            this.$store.dispatch('START_LOADING')
            this.$api.get(`/admin/tax-engine/earning-types`).then(resp => {
                this.earningTypes = resp
                this.dataLoaded = true
                this.$store.dispatch('STOP_LOADING')
            }).catch((errors) => {
                this.$store.dispatch('STOP_LOADING')
                this.$bus.showError(errors.__all__)
            })
        },
        onUpdate(earningType) {
            if (!earningType) {
                return this.getData()
            }
            const existing = this.earningTypes.find(x => x.slug == earningType.slug)
            if (existing) {
                Object.assign(existing, earningType)
            }
            else { this.getData() }
        },
    },
}

</script>
